module.exports = __webpack_public_path__ + "static/media/404.60461622.gif";